import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Image from "next/image";
import topCoverBG from "/public/top-coverBG.png";
import topCoverH from "/public/top-coverH.svg";
import leadCareers from "/public/lead-careers.svg";
// import topCover2SP from "/public/top-cover2SP.webp";
import topCover3 from "/public/top-cover3.webp";
import topCover3SP from "/public/top-cover3SP.webp";
import { Br } from "../molecules/Br";
import Link from "next/link";

export const Hero = (props) => {
  return (
    <Swiper
      modules={[Navigation, Pagination, Scrollbar, A11y]}
      spaceBetween={0}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      scrollbar={{ draggable: true }}
    >
      <SwiperSlide className="relative">
        <div className="absolute top-1/2 left-1/2 z-20 flex -translate-x-1/2 -translate-y-1/2 flex-col items-start justify-start gap-1 shadow-lg md:gap-4">
          <div className="relative aspect-1/1 h-auto">
            <h2 className="h-auto fluid-width-[220px,348px]">
              <Image
                src={topCoverH}
                alt="Specialize in your BUSINESS あなたのビジネスに、トッカするシステムを。株式会社トッカシステムズ ToccaSystems"
                quality={70}
                layout="fill"
                className="aspect-1/1"
              />
            </h2>
          </div>
          <Link href="/careers">
            <div className="flex w-full cursor-pointer flex-col gap-3 bg-white p-3 hover:bg-white/95 md:p-6">
              <h4 className="relative aspect-[16.6/1] h-auto w-full">
                <Image
                  src={leadCareers}
                  alt="ともに成長できる仲間を求めています。"
                  quality={70}
                  layout="fill"
                  className="aspect-[16.6/1] "
                />
              </h4>
              <p className="w-full text-justify font-bold text-sec fluid-text-[11px,16px]">
                トッカシステムズでは、新卒中途問わず
                <Br />
                正社員の通年採用を行っております。
              </p>
            </div>
          </Link>
        </div>
        <div className="relative z-0 aspect-1/1 h-auto w-full md:aspect-1.91/1">
          <Image
            src={topCoverBG}
            alt="ToccaSystemsのバイナリビジュアル"
            quality={70}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </SwiperSlide>
    </Swiper>
  );
};
